var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIcStarRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 11,
    viewBox: "0 0 12 11",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#de3530"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M156 8109L152.473 8110.854 153.147 8106.927 150.294 8104.146 154.237 8103.573 156 8100 157.763 8103.573 161.706 8104.146 158.853 8106.927 159.527 8110.854z",
    transform: "translate(-150 -8100)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcStarRed);
export default __webpack_public_path__ + "static/media/ic-star-red.ee24d8ff58a0bea57139a0dfc927554f.svg";
export { ForwardRef as ReactComponent };